import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Container } from './components/Styled'
import { List } from './scenes/List'
import { Details } from './scenes/Details'

export const Subscriptions = () => {
  return (
    <Container>
      <Switch>
        <Route
          exact
          path='/customer/account/subscriptions'
          component={List}
        />

        <Route
          path='/customer/account/subscriptions/detail/:id/:sku'
          component={Details}
        />

        <Redirect
          to='/customer/account/subscriptions'
        />
      </Switch>
    </Container>
  )
}
